function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomDesignatedSmokingAreFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 3H3v26h26V3zM3 1a2 2 0 00-2 2v26a2 2 0 002 2h26a2 2 0 002-2V3a2 2 0 00-2-2H3z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 18h14v-2H6.1A1.1 1.1 0 005 17.1v4.8A1.1 1.1 0 006.1 23H21v-2H7v-3zM22 23v-7h2v7h-2zm3 0v-7h2v7h-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.356 10.01c3.07 0 5.566 2.239 5.566 4.99H27c0-3.857-3.429-6.994-7.644-6.994-1.256 0-2.278-.9-2.278-2.006H15c0 2.212 1.953 4.01 4.356 4.01z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.644 10.99c-3.07 0-5.566-2.239-5.566-4.99H12c0 3.857 3.429 6.993 7.644 6.993 1.256 0 2.278.9 2.278 2.007H24c0-2.212-1.954-4.01-4.356-4.01z",
    fill: props.color
  }));
}

export default SvgIconRoomDesignatedSmokingAreFilled;